import { EventConstants } from "~/assets/constants/ecomApi";

// Extracting required fields dynamically
const transformOrderData = (orderData) => {
//     const deliveryMethodItem = orderData?.items?.find(item => item.product.sellable === false);
//   const deliveryMethodCode = deliveryMethodItem ? deliveryMethodItem.product.code : "";
    return {
  
      transaction_id: orderData?.id || null,
      value: orderData?.order_totals?.raw || 0,
      tax: 0, 
      shipping: 0,
      shipping_tier: "Ground",
      currency: EventConstants.currency, 
      coupon:  "",    
    //   delivery_method_code: deliveryMethodCode,
      items: orderData?.items?.map((item, index) => ({
        item_id: item.product.code,
        item_name: item.product.name,
        affiliation: "Toolstation",
        coupon: "", 
        discount: 0, 
        index: index,
        item_brand: "", 
        item_category: `Sub-Department-${item.product.sub_department_id}`,
        item_category2: "",
        item_category3: "",
        item_list_name: "Related products",
        item_list_id: "related_products",
        item_variant: item.product.pack_size || "",
        location_id: orderData?.delivery_address_id || "",
        price: item.prices.product_raw,
        promotion_id: "",
        promotion_name: "", 
        quantity: item.item_quantity,
      })) || [],
    };
  };
  
const transformUserData =(data: any)=>{
   return { 
          user_id: data.customer_id,
          customer_first_name: data.customer_first_name,
          customer_last_name: data.customer_last_name,
          }
}
export const logPurchaseEvent=(orderData:any,userData:any) => {

const transformedData = transformOrderData(orderData.data);

logEvent({
  options: {
    eventAction: "page_view",
    eventProperties: userData,
    ecommerce:transformedData,
    eventInteraction: true,
    eventLabel: `User Purchase Successfully`,
    eventName: "purchase",
  },
},true);
    
}
export const logDatadogPurchaseEvent=(orderData:any,response:any,params:any) => {

const transformedData = transformOrderData(orderData.data);
const userData = transformUserData(orderData.data);
logDatadogAction("purchase",{order_details:transformedData,user_details:userData,response:response,params:params});
}